<template>
  <b-form-group
    label="Buton Etiketi"
    label-for="button"
  >
    <b-form-input
      id="button"
      v-model="itemData.button"
      placeholder="Buton Etiketi"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'ButtonText',
  components: {
    BFormGroup,
    BFormInput,
  },
  computed: {
    itemData() {
      return this.$store.getters['modLeads/dataItem']
    },
  },
}
</script>
